import { create } from 'zustand';

import { ZorTerritorySettings } from '@/types/zor.territory-settings.type';

export interface ZorTerritorySettingsState {
  zorTerritorySettings: ZorTerritorySettings | undefined;
  setZorTerritorySettings: (zorGeneralSetting: ZorTerritorySettings) => void;
}

const useZorTerritorySettingsStore = create<ZorTerritorySettingsState>(
  (set) => ({
    zorTerritorySettings: undefined,
    setZorTerritorySettings: (zorTerritorySettings: ZorTerritorySettings) =>
      set(() => ({ zorTerritorySettings })),
  })
);

export { useZorTerritorySettingsStore };
